class RoCartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = this.querySelector('.js-cart-notification');
    this.onBodyClick = this.handleBodyClick.bind(this);
  }

  open() {
    this.notification.classList.add('js-open');

    this.notification.focus();
    trapFocus(this.notification);

    setTimeout(() => {
      this.close();
    }, 5000);
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('js-open');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'ro-cart-notification-product',
        selector: `[id="ro-cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'ro-cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const element = parsedHTML.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('ro-cart-notification'))
      this.close();
  }

}

customElements.define('ro-cart-notification', RoCartNotification);

